import type { PrintDoc, PrintSize } from './print-types';

const DEFAULTS: Record<PrintDoc, PrintSize> = {
  receipt: '80mm',
  refund: '80mm',
  invoice: 'a4',
  'credit-note': 'a4',
};

const key = (doc: PrintDoc): string => `nks.printSize.${doc}`;

/**
 * The size this device last printed the document at. Storage can throw
 * (private mode, blocked site data); the answer is then the default, because
 * a cashier must still be able to print.
 */
export function getPrintSize(doc: PrintDoc): PrintSize {
  try {
    const stored = localStorage.getItem(key(doc));
    if (stored === '80mm' || stored === 'a4') return stored;
  } catch {
    // fall through to the default
  }
  return DEFAULTS[doc];
}

export function setPrintSize(doc: PrintDoc, size: PrintSize): void {
  try {
    localStorage.setItem(key(doc), size);
  } catch {
    // not remembering is acceptable; failing to print is not
  }
}
